// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const environment: any;

export const currentEnv = environment.environment;
if (currentEnv !== 'production') {
    console.log('environment = ', environment);
}

export const wcmUrls = {
    calculatorConfig: environment.calculatorConfig,
    strategyTypeTooltip: environment.strategyTypeTooltip,
    indicesTooltip: environment.indicesTooltip,
    protectionTooltip: environment.protectionTooltip,
    stepRateTooltip: environment.stepRateTooltip,
    tierLevelTooltip: environment.tierLevelTooltip,
    downMarketTooltip: environment.downMarketTooltip,
    upMarketTooltip: environment.upMarketTooltip,
};

export const pdfUrlPattern = environment.pdfUrlPattern;

export const validTermLengths = [1, 3, 6];
export const minimumPremiumPayment = 25000;
export const maximumPremiumPayment = 5000000;
export const maxStrategyCount = 3;



export enum StrategyTabIndices {
    Strategy1 = 0,
    Strategy2 = 1,
    Strategy3 = 2
}

export const shareClasses = new Map<string, string>([
    ['ishare', 'I Share'],
    ['bshare', 'B Share']
]);

export const DEFAULT_START_DATE = 2001;
export const DEFAULT_END_DATE = 2020;
export const MarketNames = {
    UPMARKET : 'Up Market',
    DOWNMARKET :'Down Market',
    DOWNMARKET_LESS_THAN_BUFFERED : 'Down Market (≤ Buffer)',
    DOWNMARKET_GREATER_THAN_BUFFERED :'Down Market (> Buffer)',
    TERM : 'Custom Range'
} ;

export const EXPORT_PDF_SUMMARY_SUBTITLE = "Customize the summary report by entering the client’s name as well as the financial professional’s name.";
export const CLIENT_NAME_VALIDATION_MESSAGE = "Please enter the client’s full name.";
export const FINANCIAL_PROFESSIONAL_NAME_VALIDATION_MESSAGE =
  "Please enter the financial professional’s name.";